var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotalvipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0f0f2;\n      }\n\n      .cls-2 {\n        fill: #eb0029;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.11,182.82h-95.87c-5.47,0-10.49,2.97-13.12,7.76l-65.95,120.05c-3.29,6,1.04,13.33,7.88,13.33h95.87c5.47,0,10.49-2.98,13.12-7.77l65.95-120.05c3.29-6-1.04-13.31-7.88-13.31ZM235.8,202.96l-55.74,101.45c-1.82,3.31-5.29,5.36-9.07,5.36h-74.08c-3.07,0-5.03-3.29-3.54-5.98l55.72-101.45c1.82-3.31,5.3-5.36,9.08-5.36h74.08c3.07,0,5.01,3.29,3.54,5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.19,196.13l-65.95,120.06c-2.63,4.79-7.66,7.76-13.12,7.76h-58.3c-3.28,0-6.3-1.79-7.88-4.66l-18.75-34.14c-1.99-3.61.63-8.03,4.75-8.03h41.41c.54,0,1.04-.3,1.3-.77l47.11-85.77c2.63-4.79,7.66-7.76,13.12-7.76h48.42c6.84,0,11.17,7.33,7.88,13.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.71,277.12h57.23c3.28,0,6.3,1.79,7.88,4.66l18.39,33.48c2.15,3.91-.68,8.69-5.14,8.69h-57.23c-3.28,0-6.3-1.79-7.88-4.66l-18.39-33.48c-2.15-3.91.68-8.69,5.14-8.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotalvipIcon);
export default __webpack_public_path__ + "static/media/motalvip-icon.01988ad430847fc8270da73060315625.svg";
export { ForwardRef as ReactComponent };